import { IRentedPropertyDetail } from "../types/ownerDashboard.types";

const VACATING_BADGE_LABEL = "Em desocupação";
const RENTED_STATUS_LABEL = "Alugado";
const EXPECTED_VACATE_PREFIX = "Previsão de saída:";

/**
 * Formats Superlógica ISO dates without timezone conversion so a
 * date-only value like 2026-08-31 never shifts to the previous day.
 */
export function formatExpectedVacateDate(
  isoDate: string | null | undefined
): string | null {
  if (!isoDate || typeof isoDate !== "string") {
    return null;
  }

  const trimmed = isoDate.trim();
  if (!trimmed) {
    return null;
  }

  const dateOnlyMatch = /^(\d{4})-(\d{2})-(\d{2})/.exec(trimmed);
  if (!dateOnlyMatch) {
    return null;
  }

  const [, year, month, day] = dateOnlyMatch;
  const monthNumber = Number(month);
  const dayNumber = Number(day);

  if (monthNumber < 1 || monthNumber > 12 || dayNumber < 1 || dayNumber > 31) {
    return null;
  }

  return `${day}/${month}/${year}`;
}

export function shouldShowVacatingIndicator(
  property: Pick<IRentedPropertyDetail, "is_vacating"> | null | undefined
): boolean {
  return property?.is_vacating === true;
}

export function getPropertyStatusLabel(
  property: Pick<IRentedPropertyDetail, "is_vacating"> | null | undefined
): string {
  return shouldShowVacatingIndicator(property)
    ? VACATING_BADGE_LABEL
    : RENTED_STATUS_LABEL;
}

export function getExpectedVacateLabel(
  isoDate: string | null | undefined
): string | null {
  const formattedDate = formatExpectedVacateDate(isoDate);
  if (!formattedDate) {
    return null;
  }

  return `${EXPECTED_VACATE_PREFIX} ${formattedDate}`;
}
